/**
 * App-wide configuration (external links, etc.)
 */
export const config = {
  /** Phottr website (external) */
  websiteUrl: 'https://www.phottr.com/',
  /** Terms and Conditions (external) */
  termsUrl: 'https://www.phottr.com/app/terms-and-conditions/',
  /** Privacy Policy (external) */
  privacyPolicyUrl: 'https://www.phottr.com/app/privacy-policy/',
} as const;
